import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AccessPage() {
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      window.location.replace("/");
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/magic-link/verify`, { token }, { withCredentials: true });
        window.location.replace(data.paid ? "/dashboard" : "/");
      } catch (err) {
        const detail = err?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Accesso non riuscito. Richiedi un nuovo link.");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="tl-paper p-8 max-w-md text-center" data-testid="access-page">
        {error ? (
          <>
            <XCircle className="mx-auto text-[#C48B97]" size={40} strokeWidth={1.5} />
            <div className="mt-4 font-serif-display text-2xl text-[#3B443D]">Link non valido</div>
            <div className="mt-2 text-sm text-[#6A7368]" data-testid="access-error">{error}</div>
            <a
              href="/"
              className="tl-btn-primary mt-6 inline-block px-6 py-3 bg-[#A3B897] hover:bg-[#8FA087] text-white rounded-full text-sm font-medium transition-all"
              data-testid="access-back-home"
            >
              Richiedi un nuovo link
            </a>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto text-[#A3B897] animate-spin" size={40} strokeWidth={1.5} />
            <div className="mt-4 font-serif-display text-3xl text-[#3B443D]">Un attimo…</div>
            <div className="mt-2 text-sm text-[#6A7368]">Stiamo aprendo il tuo planner.</div>
          </>
        )}
      </div>
    </div>
  );
}
